// Поведение мегаменю шапки. Разметка серверная (application/_mega_menu*),
// здесь только состояние: задержка намерения перед раскрытием, мгновенное
// переключение между панелями, закрытие по Esc, клику вне и скроллу, плюс
// цели в Метрику. Пока модуль не поднялся, панели раскрываются по
// :hover/:focus-within — за это отвечает mega-menu.scss, а корень меню
// помечается data-mega-menu-js, чтобы правила уступили место классам.

// Задержка намерения перед первым открытием по наведению и отсрочка
// закрытия после ухода курсора. Переключение между уже открытыми панелями —
// мгновенное, без задержки.
const INTENT_MS = 180;
const GRACE_MS = 280;
// Окно после мгновенного переключения панели наведением, в котором клик по
// тому же пункту считается подтверждением («да, я сюда шёл»), а не командой
// закрыть: наведение при открытой панели переключает её ещё до клика, и без
// этого окна клик захлопывал бы всё меню.
const HOVER_SWITCH_CLICK_MS = 500;
const SCROLL_CLOSE_PX = 50;
const PROD_METRIKA_ID = 46196496;

// Цели уходят тем же счётчиком, что и остальная аналитика сайта (его
// поднимает App.analytics). Где Метрика заблокирована — вызов молча ничего
// не делает и навигацию не задерживает.
function goal(name, params) {
  if (typeof window.ym !== 'function') {
    return;
  }

  window.ym(window.App?.analytics?.ymTracker ?? PROD_METRIKA_ID, 'reachGoal', name, params);
}

function linkParams(link) {
  const group = link.closest('[data-mega-group]');
  const panel = link.closest('[data-mega-panel]');
  const links = group ? [...group.querySelectorAll('a[data-mega-label]')] : [];

  // В текстах меню неразрывные пробелы — в аналитику отдаём обычные,
  // чтобы label и group не разъехались с уже накопленными значениями.
  return {
    panel: panel?.dataset.megaPanel ?? '',
    group: (group?.dataset.megaGroup ?? '—').replaceAll('\u00A0', ' '),
    label: (link.dataset.megaLabel ?? '').replaceAll('\u00A0', ' '),
    position: links.indexOf(link) + 1,
    href: link.getAttribute('href'),
  };
}

// «С помощью ассистента» открывает виджет поддержки: класс intercom-activate
// ловит глобальный обработчик (utils/intercom), он же покажет заглушку, если
// виджет заблокирован расширением. Переход по запасной ссылке отменяем.
function handleLinkClick(link, event) {
  goal('menu_link_click', linkParams(link));

  if (link.classList.contains('intercom-activate')) {
    event.preventDefault();
  }
}

function initDesktop(root) {
  const items = [...root.querySelectorAll('[data-mega-item]')];
  const panel = root.querySelector('.mega-panel');

  if (!items.length || !panel) {
    return;
  }

  root.setAttribute('data-mega-menu-js', '');

  const bodyOf = (item) => panel.querySelector(`[data-mega-panel="${item.dataset.megaItem}"]`);

  let openItem = null;
  let intentTimer = null;
  let graceTimer = null;
  let openScrollY = 0;
  let hoverSwitchItem = null;
  let hoverSwitchAt = 0;

  const clearIntent = () => {
    window.clearTimeout(intentTimer);
    intentTimer = null;
  };

  const clearGrace = () => {
    window.clearTimeout(graceTimer);
    graceTimer = null;
  };

  const setOpen = (item, isOpen) => {
    item.classList.toggle('is-open', isOpen);
    item.querySelector('.mega-menu__trigger')?.setAttribute('aria-expanded', String(isOpen));
    bodyOf(item)?.classList.toggle('is-active', isOpen);
  };

  // Высота карточки всегда задана явно: так переключение раздела плавно
  // меняет высоту, а не переоткрывает карточку. На первое открытие высота
  // ставится мгновенно — анимируются только прозрачность и сдвиг.
  const syncHeight = (instant) => {
    if (!openItem) {
      return;
    }

    if (instant) {
      panel.classList.add('mega-panel--no-height-anim');
    }

    panel.style.height = `${bodyOf(openItem)?.scrollHeight ?? 0}px`;

    if (instant) {
      // Принудительный пересчёт стилей, пока транзишен высоты отключён:
      // к следующему кадру анимировать уже нечего.
      panel.getBoundingClientRect();
      panel.classList.remove('mega-panel--no-height-anim');
    }
  };

  const close = () => {
    clearIntent();
    clearGrace();

    if (openItem) {
      setOpen(openItem, false);
    }

    root.classList.remove('is-open');
    panel.style.height = '0px';
    openItem = null;
    hoverSwitchItem = null;
  };

  const open = (item, trigger) => {
    clearGrace();

    if (openItem === item) {
      return;
    }

    const switching = Boolean(openItem);

    if (openItem) {
      setOpen(openItem, false);
    }

    if (!switching) {
      openScrollY = window.scrollY;
    }

    setOpen(item, true);
    root.classList.add('is-open');
    openItem = item;
    syncHeight(!switching);
    goal('menu_panel_open', {
      panel: item.dataset.megaItem,
      trigger,
      mode: switching ? 'switch' : 'open',
    });
  };

  const scheduleClose = () => {
    if (!openItem || graceTimer !== null) {
      return;
    }

    graceTimer = window.setTimeout(close, GRACE_MS);
  };

  items.forEach((item) => {
    const trigger = item.querySelector('.mega-menu__trigger');

    item.addEventListener('pointerenter', (e) => {
      // Тач не «наводится» — там панель живёт только от тапа-клика.
      if (e.pointerType === 'touch') {
        return;
      }

      clearGrace();

      if (openItem) {
        if (openItem !== item) {
          open(item, 'hover');
          hoverSwitchItem = item;
          hoverSwitchAt = performance.now();
        }

        return;
      }

      clearIntent();
      intentTimer = window.setTimeout(() => {
        intentTimer = null;
        open(item, 'hover');
      }, INTENT_MS);
    });

    item.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'touch') {
        return;
      }

      clearIntent();
      scheduleClose();
    });

    trigger?.addEventListener('click', (e) => {
      clearIntent();

      if (openItem === item) {
        // Панель только что переключило сюда наведение — пользователь ещё
        // не видел её «своей» и кликом подтверждает выбор.
        if (hoverSwitchItem === item && performance.now() - hoverSwitchAt < HOVER_SWITCH_CLICK_MS) {
          hoverSwitchItem = null;

          return;
        }

        close();

        return;
      }

      // detail === 0 — клик синтезирован Enter/Space с клавиатуры.
      open(item, e.detail === 0 ? 'keyboard' : 'click');
    });
  });

  // Курсор ушёл с пункта на саму карточку — она остаётся раскрытой.
  panel.addEventListener('pointerenter', (e) => {
    if (e.pointerType !== 'touch') {
      clearGrace();
    }
  });

  panel.addEventListener('pointerleave', (e) => {
    if (e.pointerType !== 'touch') {
      scheduleClose();
    }
  });

  // Высота пересчитывается сама: догрузилась промо-картинка, подъехал
  // шрифт — раскрытая карточка не должна обрезать содержимое.
  const resizeObserver = new ResizeObserver(() => syncHeight(false));

  panel.querySelectorAll('[data-mega-panel]').forEach((body) => resizeObserver.observe(body));
  window.addEventListener('resize', () => syncHeight(false));

  root.addEventListener('click', (e) => {
    const promo = e.target.closest('[data-mega-promo]');

    if (promo) {
      goal('menu_promo_click', { panel: promo.closest('[data-mega-panel]')?.dataset.megaPanel });
      close();

      return;
    }

    const link = e.target.closest('a[data-mega-label]');

    if (link) {
      handleLinkClick(link, e);
      close();
    }
  });

  // Клик и уход фокуса за пределы меню закрывают панель.
  document.addEventListener('click', (e) => {
    if (openItem && !root.contains(e.target)) {
      close();
    }
  });

  document.addEventListener('focusin', (e) => {
    if (openItem && !root.contains(e.target)) {
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !openItem) {
      return;
    }

    const trigger = openItem.querySelector('.mega-menu__trigger');

    close();
    trigger?.focus();
  });

  // Скролл дальше 50px от точки открытия — панель закрывается.
  window.addEventListener('scroll', () => {
    if (openItem && Math.abs(window.scrollY - openScrollY) > SCROLL_CLOSE_PX) {
      close();
    }
  }, { passive: true });
}

function initMobile(root) {
  const burger = root.querySelector('.mega-mobile__burger');

  // Пока меню открыто, страница под ним не скроллится.
  root.addEventListener('toggle', () => {
    document.body.style.overflow = root.open ? 'hidden' : '';

    if (root.open) {
      goal('menu_mobile_open');
    }
  });

  root.querySelectorAll('[data-mega-panel]').forEach((acc) => {
    acc.addEventListener('toggle', () => {
      if (acc.open) {
        goal('menu_mobile_section_expand', { panel: acc.dataset.megaPanel });
      }
    });
  });

  root.addEventListener('click', (e) => {
    const link = e.target.closest('a[data-mega-label], .mega-mobile__flat');

    if (!link) {
      return;
    }

    if (link.dataset.megaLabel) {
      handleLinkClick(link, e);
    }

    root.open = false;
    // Кликнутая ссылка может никуда не увести (виджет поддержки) — фокус
    // возвращаем на бургер, чтобы клавиатурный пользователь не остался
    // «в пустоте».
    burger?.focus();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.open) {
      root.open = false;
      burger?.focus();
    }
  });
}

function init() {
  document.querySelectorAll('[data-mega-menu]').forEach(initDesktop);
  document.querySelectorAll('[data-mega-mobile]').forEach(initMobile);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
